import React, { useEffect, useState } from 'react'
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { DigitalVaultStatisticalReportView } from '../../views';
import { DigitalVaultService, LocalStorageService } from '../../../services';

const DigitalVaultStatisticalReportAction = (props) => {
    const {
        toggleCompletedRequesting,
        toggleLoadingRequesting,
        toggleErrorRequesting,

        selectedCompanyId,
        setSelectedDocumentId,
        t
    } = props;

    const url = process.env.REACT_APP_MIFIRMA_API;
    const localStorageService = new LocalStorageService();
    const token = localStorageService.getLocalStorageItem("token").idToken;
    const digitalVaultService = new DigitalVaultService(url);

    const [isLoading, setIsLoading] = useState(true);

    const [documentActions, setDocumentActions] = useState([]);
    const [allTopDocuments, setAllTopDocuments] = useState([]);
    const [confidentialDocuments, setConfidentialDocuments] = useState([]);
    const [totalAlerts, setTotalAlerts] = useState([]);
    const [spaceUsed, setSpaceUsed] = useState([]);

    const loadReport = async () => {
        setIsLoading(true);

        try {
            let response = await digitalVaultService.getStatisticalReport(token, selectedCompanyId === 0 ? null : selectedCompanyId)
            if (response.statusCode === 200 && response.data) {
                const topdocs = response.data.topDocuments.map(doc => ({
                    count: doc.counts,
                    id: doc.documentId,
                    name: doc["document.name"],
                    documentActionId: doc.documentActionId
                }))
                const translatedDocumentActions = response.data.documentActions.map(item => ({
                    ...item,
                    translatedName: t(`digitalVaultStatisticalReportView.key.${item.name}`)
                }))
                setAllTopDocuments(topdocs);
                setDocumentActions(translatedDocumentActions);
                setConfidentialDocuments(response.data.confidentialDocuments)
                setTotalAlerts(response.data.totalAlerts)
                setSpaceUsed(response.data.spaceUsed);
            } else {
                throw new Error(response.message || t("digitalVaultStatisticalReportView.errors.general"))
            }
            setIsLoading(false);
        } catch (e) {
            toggleErrorRequesting(true, e.message, 4000, true)
        }
    }

    useEffect(() => {
        loadReport();
    }, [selectedCompanyId])

    return (
        <DigitalVaultStatisticalReportView
            t={t}
            isLoading={isLoading}
            setSelectedDocumentId={setSelectedDocumentId}
            allTopDocuments={allTopDocuments}
            documentActions={documentActions}
            confidentialDocuments={confidentialDocuments}
            totalAlerts={totalAlerts}
            spaceUsed={spaceUsed}
        />
    )
}

export default withRouter(withTranslation()(DigitalVaultStatisticalReportAction));